import { render, staticRenderFns } from "./Expiries.vue?vue&type=template&id=411e4b88&"
import script from "./Expiries.vue?vue&type=script&lang=js&"
export * from "./Expiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports